import React from 'react';

import { Empty, EmptyProps, Loading } from 'components';
import { CCTableContext, CCTableContextProvider, Column, DisplayMode, Row } from './cc-table.context';
import { CCTableActions } from './cc-table-actions';
import { CCTableDesktop } from './desktop';
import { CCTableMobile } from './mobile';

export interface CCTableProps {
  title?: string;
  columns?: Column[];
  rows?: Row[];
  tableActionsComponent?: React.Component;
  tableActionsComponentProps?: {
    [key: string]: any;
  };
  loading?: {
    isLoading?: boolean;
    text?: string;
  };
  empty?: EmptyProps;
  displayMode?: DisplayMode;
}

export const CCTable = ({
  title = '',
  columns = [],
  rows = [],
  tableActionsComponent = CCTableActions as any,
  tableActionsComponentProps = {},
  loading: { isLoading = false, text = 'Loading...' } = {},
  empty = {},
  displayMode,
}: CCTableProps) => {
  if (isLoading) {
    return <Loading text={text} height={300} />;
  }

  if (rows.length === 0) {
    return <Empty {...empty} />;
  }

  return (
    <CCTableContextProvider
      title={title}
      columns={columns}
      rows={rows}
      tableActionsComponent={tableActionsComponent}
      tableActionsComponentProps={tableActionsComponentProps}
      displayMode={displayMode}
    >
      <CCTableContext.Consumer>
        {({ displayMode }) => (displayMode === 'table' ? <CCTableDesktop /> : <CCTableMobile />)}
      </CCTableContext.Consumer>
    </CCTableContextProvider>
  );
};
